
const mapStyle = `https://api.mapbox.com/styles/v1/samuels8833/clmkv0r9b04e101qxc3ed9xwa?access_token=${process.env.NEXT_PUBLIC_MAPBOX_TOKEN}`;

export { mapStyle };
